import React from 'react';

interface ComingSoonModalProps {
  isOpen: boolean;
  onClose: () => void;
  featureName: string;
}

const ComingSoonModal: React.FC<ComingSoonModalProps> = ({
  isOpen,
  onClose,
  featureName,
}) => {
  if (!isOpen) return null;

  return (
    <div className='fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center p-4 z-50'>
      <div className='bg-white rounded-2xl shadow-xl max-w-md w-full p-6'>
        <div className='text-center mb-6'>
          <div className='w-16 h-16 mx-auto mb-4 bg-blue-100 rounded-full flex items-center justify-center'>
            <svg
              className='w-8 h-8 text-blue-600'
              fill='none'
              stroke='currentColor'
              viewBox='0 0 24 24'
            >
              <path
                strokeLinecap='round'
                strokeLinejoin='round'
                strokeWidth={2}
                d='M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z'
              />
            </svg>
          </div>
          <h3 className='text-2xl font-bold text-gray-900 mb-2'>
            Coming Soon!
          </h3>
          <div className='text-gray-600'>
            <p className='mb-4'>
              Thank you for your interest in{' '}
              <span className='font-semibold text-blue-600'>{featureName}</span>
              ! We're working hard to bring you this feature and will let you
              know as soon as it's live.
            </p>
            <p className='text-sm text-gray-500'>Stay tuned for updates! 🚀</p>
          </div>
        </div>

        {/* Action Button */}
        <div className='flex justify-center'>
          <button
            onClick={onClose}
            className='w-full px-6 py-3 bg-blue-600 text-white rounded-lg font-medium hover:bg-blue-700 transition-colors'
          >
            Got it!
          </button>
        </div>
      </div>
    </div>
  );
};

export default ComingSoonModal;
